import React from "react";

const StatCard = ({ title, value, Icon, iconSize }) => {
  return (
    <div className="flex flex-col gap-2 p-5 rounded-xl bg-white border border-[#a48572]/10 w-full">
      <p className="text-sm text-[#de2b26]/70">{title}</p>
      <div className="flex justify-between items-center">
        <p className="text-[20px] font-medium text-[#142b70]">{value}</p>
        <div className="flex justify-center items-center w-10 h-10 rounded-md bg-[#edc9b7]/20">
          <Icon color="#142b70" size={iconSize} />
        </div>
      </div>
    </div>
  );
};

export default StatCard;
